import apiFeedbackInfos from '@/api/feedback'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  feedbackInfo: null,
}

export const mutationTypes = {
  getFeedbackInfoStart: '[feedbackInfo] Get feedbackInfo start',
  getFeedbackInfoSuccess: '[feedbackInfo] Get feedbackInfo success',
  getFeedbackInfoFailure: '[feedbackInfo] Get feedbackInfo failure',

  updateFeedbackInfoStart: '[feedbackInfo] Update feedbackInfo start',
  updateFeedbackInfoSuccess: '[feedbackInfo] Update feedbackInfo success',
  updateFeedbackInfoFailure: '[feedbackInfo] Update feedbackInfo failure',
}

export const actionTypes = {
  getFeedbackInfo: '[feedbackInfo] Get feedbackInfo',
  updateFeedbackInfo: '[feedbackInfo] Update feedbackInfo',
}

const mutations = {
  [mutationTypes.getFeedbackInfoStart](state) {
    state.isLoading = true
    state.feedbackInfo = null
  },

  [mutationTypes.getFeedbackInfoSuccess](state, payload) {
    state.feedbackInfo = payload
    state.isLoading = false
  },

  [mutationTypes.getFeedbackInfoFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.updateFeedbackInfoStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateFeedbackInfoSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateFeedbackInfoFailure](state) {
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.getFeedbackInfo](context, {id}) {
    context.commit(mutationTypes.getFeedbackInfoStart)
    return new Promise((resolve) => {
      apiFeedbackInfos
        .getFeedbackInfo(id)
        .then((response) => {
          context.commit(mutationTypes.getFeedbackInfoSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getFeedbackInfoFailure)
        })
    })
  },

  [actionTypes.updateFeedbackInfo](context, {feedbackId, data}) {
    context.commit(mutationTypes.updateFeedbackInfoStart)
    return new Promise((resolve) => {
      apiFeedbackInfos
        .changeFeedbackStatus(feedbackId, data)
        .then((response) => {
          context.commit(mutationTypes.updateFeedbackInfoSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.updateFeedbackInfoFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
